import { render, staticRenderFns } from "./Verifactus.vue?vue&type=template&id=d7b5f7c8&scoped=true"
import script from "./Verifactus.vue?vue&type=script&lang=js"
export * from "./Verifactus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b5f7c8",
  null
  
)

export default component.exports